// extracted by mini-css-extract-plugin
export default {"logo":"Testimonial_logo__SBs7V","avatar":"Testimonial_avatar__A1F3v"};